import PrivacyPolicy from './PrivacyPolicy.kr'
import TermsAgreement from './TermsAgreement.kr'
import TermsService from './TermsService.kr'
export default {
  ...PrivacyPolicy,
  ...TermsAgreement,
  ...TermsService
}


// WEBPACK FOOTER //
// ./src/lang/terms/kr.js